export default __webpack_public_path__ + "static/media/jeff_sieh.4bd2b3c6.png";